import { useMemo } from 'react';
import { TalentCategory } from '@a_team/models/dist/TalentCategories';
import { getVettingFormVariant } from '@a_team/models/dist/vetting-processes/vetting-processes';

export function useVettingFormVariant(category?: TalentCategory | undefined) {
  const variant = useMemo(() => getVettingFormVariant(category), [category]);

  return variant;
}
